import { atom } from 'jotai';

const selectAndSearchAtom = atom(false);

export { selectAndSearchAtom };